import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title>{props.title || 'Ok'}</title>
      <g>
        <path d="M200.5 447.6c-2.3 1.8-4.7 3-7.6 3-2.9 0-5.3-1.2-7.6-3l-180-179.9c-4.1-4.1-4.1-11.2 0-15.3l74.1-74.1c4.1-4.1 11.2-4.1 15.3 0l98.2 98.8 225.1-225.7c4.1-4.1 11.2-4.1 15.3 0l74.1 74.1c4.1 4.1 4.1 11.2 0 15.3l-306.9 306.8z" />
      </g>
    </Icon>
  )
}
